export const PAGE_PATH = '/admin-withdraw';
